import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import AppBar from "./AppBar";
import { Trans } from "react-i18next";
import { Container } from "@material-ui/core";
import { useHistory } from "react-router";
import LoadingButton from "../../../../../components/LoadingButton";
import { BuyProductView } from "@/react/Webshop/Components/Template/BuyProductView";
import { useBuyTemplateProduct } from "@/react/Webshop/hooks/useBuyTemplateProduct";

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    "& h2": {
      textAlign: "center",
    },
  },
  buttonContainer: {
    padding: theme.spacing(2),
    textAlign: "center",
  },
}));

export default ({ changeMenu }) => {
  const classes = useStyles();
  const history = useHistory();

  const buyProduct = useBuyTemplateProduct({
    onAddedToCart: () => {
      history.push("/shopping-cart");
    },
  });

  return (
    <div className={classes.mainContainer}>
      <AppBar onCancel={() => changeMenu("main")} />

      <Container maxWidth={"sm"}>
        <h2>
          <Trans>Select quantity</Trans>
        </h2>

        <BuyProductView {...buyProduct} />
      </Container>

      <div className={classes.buttonContainer}>
        <LoadingButton
          isLoading={buyProduct.isUpdating}
          variant="primary"
          disabled={buyProduct.totalQuantity === 0}
          onClick={buyProduct.handleAddToCart}
        >
          <Trans>Add to cart</Trans>
        </LoadingButton>
      </div>
    </div>
  );
};
